import { NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { MessageToLureAction } from './interfaces/enum/message-to-lure-action.enum';

export const QUESTION_TYPES = {
  MC: 'MC',
  TF: 'TF',
  CATA: 'CA',
};
export const SUPPORTED_LANGUAGE_CODES = {
  ENGLISH: { GO: 'en-us', READER: 'en-US' },
  SPANISH: { GO: 'es-mx', READER: 'es-ES' },
};

export const SUPPORTED_ENGLISH_CODES = ['en', 'en_us', 'en-us'];
// canvas = en, BB = en_US, moodle = en_us, d2l = en-US
export const SUPPORTED_SPANISH_CODES = [
  'es',
  'es_es',
  'es_mx',
  'es-mx',
  'es-es',
];
// canvas = es, BB = es_ES, moodle = es_mx, d2l = es-MX
// moodle supports es and es_mx. Application will render es-mx for both these options for now.

export const DEFAULT_LANGUAGE_CODE = {
  ENGLISH: 'en-us',
  SPANISH: 'es-mx',
};

export const SUPPORTED_LANGUAGE_CODES_EBOOK = {
  ENGLISH: { EBOOK: 'en-us', READER: 'en-US' },
  SPANISH: { EBOOK: 'es-mx', READER: 'es-ES' },
};

export const TECH_SUPPORT_CENTER_URL = 'https://mh.my.site.com/CXG/s/';

export const SM_MODAL_PARAMS: NgbModalOptions = {
  size: 'sm',
  keyboard: true,
  backdrop: true,
  centered: true,
  ariaLabelledBy: 'modal-aria-heading',
  ariaDescribedBy: 'modal-aria-body',
};

export const MD_MODAL_PARAMS: NgbModalOptions = {
  size: 'md',
  keyboard: true,
  backdrop: true,
  centered: true,
  ariaLabelledBy: 'modal-aria-heading',
  ariaDescribedBy: 'modal-aria-body',
};

export const XL_MODAL_PARAMS: NgbModalOptions = {
  size: 'xl',
  keyboard: true,
  backdrop: true,
  centered: true,
  ariaLabelledBy: 'modal-aria-heading',
  ariaDescribedBy: 'modal-aria-body',
};

export const LG_MODAL_PARAMS: NgbModalOptions = {
  size: 'lg',
  keyboard: true,
  backdrop: true,
  centered: true,
  ariaLabelledBy: 'modal-aria-heading',
  ariaDescribedBy: 'modal-aria-body',
};

export const MESSAGE_TO_LURE: Record<MessageToLureAction, string> = {
  [MessageToLureAction.CLOSE]: 'com.mheducation.openlearning.lti.close',
  [MessageToLureAction.UNPAIR_SECTION]:
    'com.mheducation.openlearning.lti.unpairSection',
  [MessageToLureAction.GRADE_RESYNC]:
    'com.mheducation.openlearning.lti.gradeResync',
  [MessageToLureAction.RESYNC]: 'com.mheducation.openlearning.lti.resync',
};
